import { Environment } from '../constants/env'

const SHEETGO_USER_AUTH_ENCRYPT_KEY = 'SHEETGOWEBSITE'
const SHEETGO_APP_STATE_ENCRYPT_KEY = '4PZ$T4T3$'
const SHEETGO_WEBSITE = ['www.sheetgo.com', 'sheetgo.com']

const PLAN_YEAR_SUFFIX = '2023'
const DEFAULT_INTERCOM_APP_ID = 'adhexofg'
const MAX_CELLS_TRANSFER_FORMAT = 350000

// Public Brandfetch Logo Link client ID (browser-safe), used to hotlink brand
// logos for API connections via cdn.brandfetch.io. Same value across environments.
// Key belongs to Jonatan and is on the free tier — upgrade if we hit the limits.
// Rate limits: https://docs.brandfetch.com/brand-search-api/rate-limits
const BRANDFETCH_CLIENT_ID = '1iddM-LtzQOKULiJtnx'

const envs = {
    [Environment.PROD]: {
        name: Environment.PROD,
        appURL: 'https://app.sheetgo.com',
        apiURL: 'https://api.sheetgo.com',
        wsURL: 'https://api.sheetgo.com',
        msappURL: 'https://msapp.sheetgo.com',
        formsAppURL: 'https://forms.sheetgo.com',
        dashboardsAppURL: 'https://dashboards.sheetgo.com',
        barcodeDetectorURL: 'https://prod-barcode-scanner-oyhudlts6q-uc.a.run.app',
        oneSignalAppId: 'd89159e7-6b19-4748-8a0d-b8d1a24b6151',
        oauthClientId: '15129741696-gg0p598ba13ijb4cb7tk3rdai3fmu5bg.apps.googleusercontent.com',
        oauthClientIdAlt: '94172092257-3hhhdvmta2he1a9oi7iove95qg2t2a8t.apps.googleusercontent.com',
        geolocationApiKey: '726f901fb0da17',
        oktaIssuerDomain: 'https://dev-21489187.okta.com',
        oktaClientId: '0oac0x5x0r6iIgdfl5d6',
        hotjarId: '2631381',
        clarityId: 'n7q7fux3ep',
        reCaptchaApiKey: '6LdhfEQhAAAAAOTjerf4Oa_D0YWv_dB_gwk-vOrp',
        intercomAppId: DEFAULT_INTERCOM_APP_ID,
        openAiClientId: '',
        ancestorsRegex: new RegExp(
            '^https://n-7ixdqsk3ntqkmodnjzyunwcrhtieg7y7tpckjey-' +
            '(\\d+)lu-script\\.googleusercontent\\.com(?:/userCodeAppPanel)?$'
        ),
        dynamsoftKey: (
            'DLS2eyJoYW5kc2hha2VDb2RlIjoiMTA0MDc0NTA5LVRYbFhaV0pRY205cSIsIm1haW5TZXJ2ZXJVUkwiOiJodHRwczovL21' +
            'kbHMuZHluYW1zb2Z0b25saW5lLmNvbSIsIm9yZ2FuaXphdGlvbklEIjoiMTA0MDc0NTA5Iiwic3RhbmRieVNlcnZlclVSTC' +
            'I6Imh0dHBzOi8vc2Rscy5keW5hbXNvZnRvbmxpbmUuY29tIiwiY2hlY2tDb2RlIjoxMjgxNTY3MDUyfQ=='
        ),
        stripePublishableKeyV42: 'pk_live_51QsPrTLcwtFUBF9GGrfEGdctPWHQqbAOpJedHPosMsDZfutIXlqbP9jUEUheRqbDAmAcrSIc4Tcpy8u3EJF5u6s600eRaX9F7P',
        // Sheetgo Europe SL (EU, acct_1822) publishable key.
        // Intentionally empty: as of EU-entity Phase 3c the sign-up Radar pk is
        // sourced at runtime from /app/config (backend settings.STRIPE_PUBLISHABLE_KEY,
        // the real EU key), so this build-time value is never read on PROD/NEW — the
        // SignUpPage fallback selects the V42/US key for non-LEGACY envs regardless.
        // Kept as a fallback-only slot; leave '' until a non-Radar consumer needs it.
        stripePublishableKeyEU: ''
    },
    [Environment.LEGACY]: {
        name: Environment.LEGACY,
        appURL: 'https://legacy.sheetgo.com',
        apiURL: 'https://legacy-api.sheetgo.com',
        wsURL: 'https://legacy-api.sheetgo.com',
        msappURL: 'https://legacy-msapp.sheetgo.com',
        formsAppURL: 'https://legacy-forms.sheetgo.com',
        dashboardsAppURL: 'https://legacy-dashboards.sheetgo.com',
        barcodeDetectorURL: 'https://prod-barcode-scanner-oyhudlts6q-uc.a.run.app',
        oneSignalAppId: 'd89159e7-6b19-4748-8a0d-b8d1a24b6151',
        oauthClientId: '15129741696-gg0p598ba13ijb4cb7tk3rdai3fmu5bg.apps.googleusercontent.com',
        oauthClientIdAlt: '94172092257-3hhhdvmta2he1a9oi7iove95qg2t2a8t.apps.googleusercontent.com',
        geolocationApiKey: '726f901fb0da17',
        oktaIssuerDomain: 'https://dev-21489187.okta.com',
        oktaClientId: '0oac0x5x0r6iIgdfl5d6',
        hotjarId: '217155',
        clarityId: 'n7by3oys6s',
        reCaptchaApiKey: '6LdhfEQhAAAAAOTjerf4Oa_D0YWv_dB_gwk-vOrp',
        intercomAppId: DEFAULT_INTERCOM_APP_ID,
        openAiClientId: '',
        ancestorsRegex: /^https:\/\/([a-zA-Z0-9-]+)-(\d+)lu-script\.googleusercontent\.com(?:\/userCodeAppPanel)?$/,
        dynamsoftKey: (
            'DLS2eyJoYW5kc2hha2VDb2RlIjoiMTA0MDc0NTA5LVRYbFhaV0pRY205cSIsIm1haW5TZXJ2ZXJVUkwiOiJodHRwczovL21' +
            'kbHMuZHluYW1zb2Z0b25saW5lLmNvbSIsIm9yZ2FuaXphdGlvbklEIjoiMTA0MDc0NTA5Iiwic3RhbmRieVNlcnZlclVSTC' +
            'I6Imh0dHBzOi8vc2Rscy5keW5hbXNvZnRvbmxpbmUuY29tIiwiY2hlY2tDb2RlIjoxMjgxNTY3MDUyfQ=='
        ),
        // Intentionally empty: LEGACY routes to legacy-api.sheetgo.com (Sheetgo Europe SL).
        // v4.2 (Sheetgo Inc) publishable key would create an account mismatch.
        stripePublishableKeyV42: '',
        // Intentionally empty until the real pk_live_51822ce… Sheetgo Europe SL key lands
        // (Phase 3 gate). Empty keeps the createRadarSessionToken !publishableKey guard
        // short-circuiting so LEGACY sign-ups make no failing Stripe.js call — preserves
        // pre-Phase-2 behavior. All other envs keep the greppable placeholder for Phase-3 swap.
        stripePublishableKeyEU: ''
    },
    [Environment.NEW]: {
        name: Environment.NEW,
        appURL: 'https://new.sheetgo.com',
        apiURL: 'https://new-api.sheetgo.com',
        wsURL: 'https://new-api.sheetgo.com',
        msappURL: 'https://msapp.sheetgo.com',
        formsAppURL: 'https://new-forms.sheetgo.com',
        dashboardsAppURL: 'https://new-dashboards.sheetgo.com',
        oneSignalAppId: 'd89159e7-6b19-4748-8a0d-b8d1a24b6151',
        barcodeDetectorURL: 'https://prod-barcode-scanner-oyhudlts6q-uc.a.run.app',
        oauthClientId: '15129741696-gg0p598ba13ijb4cb7tk3rdai3fmu5bg.apps.googleusercontent.com',
        oauthClientIdAlt: '94172092257-3hhhdvmta2he1a9oi7iove95qg2t2a8t.apps.googleusercontent.com',
        geolocationApiKey: '726f901fb0da17',
        oktaIssuerDomain: 'https://dev-21489187.okta.com',
        oktaClientId: '0oac0x5x0r6iIgdfl5d6',
        hotjarId: '1819081',
        clarityId: 'n7by3oys6s',
        reCaptchaApiKey: '6LdhfEQhAAAAAOTjerf4Oa_D0YWv_dB_gwk-vOrp',
        intercomAppId: DEFAULT_INTERCOM_APP_ID,
        openAiClientId: '',
        ancestorsRegex: /^https:\/\/([a-zA-Z0-9-]+)-(\d+)lu-script\.googleusercontent\.com(?:\/userCodeAppPanel)?$/,
        dynamsoftKey: (
            'DLS2eyJoYW5kc2hha2VDb2RlIjoiMTA0MDc0NTA5LVRYbFhaV0pRY205cSIsIm1haW5TZXJ2ZXJVUkwiOiJodHRwczovL21' +
            'kbHMuZHluYW1zb2Z0b25saW5lLmNvbSIsIm9yZ2FuaXphdGlvbklEIjoiMTA0MDc0NTA5Iiwic3RhbmRieVNlcnZlclVSTC' +
            'I6Imh0dHBzOi8vc2Rscy5keW5hbXNvZnRvbmxpbmUuY29tIiwiY2hlY2tDb2RlIjoxMjgxNTY3MDUyfQ=='
        ),
        stripePublishableKeyV42: 'pk_live_51QsPrTLcwtFUBF9GGrfEGdctPWHQqbAOpJedHPosMsDZfutIXlqbP9jUEUheRqbDAmAcrSIc4Tcpy8u3EJF5u6s600eRaX9F7P',
        // Intentionally empty — see the PROD block: the Radar pk now comes from
        // /app/config at runtime; this build-time slot is never read on NEW.
        stripePublishableKeyEU: ''
    },
    [Environment.STAGING]: {
        name: Environment.STAGING,
        appURL: 'https://staging.sheetgo.com',
        apiURL: 'https://staging-api.sheetgo.com',
        wsURL: 'https://staging-api.sheetgo.com',
        msappURL: 'https://staging-msapp.sheetgo.com',
        formsAppURL: 'https://staging-forms.sheetgo.com',
        dashboardsAppURL: 'https://staging-dashboards.sheetgo.com',
        barcodeDetectorURL: 'https://prod-barcode-scanner-oyhudlts6q-uc.a.run.app',
        oneSignalAppId: '0d785d26-d366-4245-a50f-152a98408175',
        oauthClientId: '15129741696-gg0p598ba13ijb4cb7tk3rdai3fmu5bg.apps.googleusercontent.com',
        oauthClientIdAlt: '94172092257-3hhhdvmta2he1a9oi7iove95qg2t2a8t.apps.googleusercontent.com',
        geolocationApiKey: '726f901fb0da17',
        oktaIssuerDomain: 'https://dev-21489187.okta.com',
        oktaClientId: '0oac0x5x0r6iIgdfl5d6',
        hotjarId: '1819081',
        clarityId: 'n7by3oys6s',
        reCaptchaApiKey: '6LdhfEQhAAAAAOTjerf4Oa_D0YWv_dB_gwk-vOrp',
        intercomAppId: DEFAULT_INTERCOM_APP_ID,
        openAiClientId: '',
        ancestorsRegex: /^https:\/\/([a-zA-Z0-9-]+)-(\d+)lu-script\.googleusercontent\.com(?:\/userCodeAppPanel)?$/,
        dynamsoftKey: (
            'DLS2eyJoYW5kc2hha2VDb2RlIjoiMTA0MDc0NTA5LVRYbFhaV0pRY205cSIsIm1haW5TZXJ2ZXJVUkwiOiJodHRwczovL21' +
            'kbHMuZHluYW1zb2Z0b25saW5lLmNvbSIsIm9yZ2FuaXphdGlvbklEIjoiMTA0MDc0NTA5Iiwic3RhbmRieVNlcnZlclVSTC' +
            'I6Imh0dHBzOi8vc2Rscy5keW5hbXNvZnRvbmxpbmUuY29tIiwiY2hlY2tDb2RlIjoxMjgxNTY3MDUyfQ=='
        ),
        stripePublishableKeyV42: 'pk_test_51TQst5L71YIwxUx30X5KfKGdAalqzyOLkOX5LQBgG1OhSr1S958GNXqz2P5APD4zwI3O26vmhwcinMARi1Zh0b2I00ROE0SH6N',
        stripePublishableKeyEU: 'pk_test_aNiFzeQoZ6Xyk7XThjPaTRjX'
    },
    [Environment.DEV]: {
        name: Environment.DEV,
        appURL: 'https://dev.sheetgo.com',
        apiURL: 'https://dev-api.sheetgo.com',
        wsURL: 'https://dev-api.sheetgo.com',
        msappURL: 'https://dev-msapp.sheetgo.com',
        formsAppURL: 'https://dev-forms.sheetgo.com',
        dashboardsAppURL: 'https://dev-dashboards.sheetgo.com',
        barcodeDetectorURL: 'https://testing-barcode-scanner-x3efltvidq-uc.a.run.app',
        oneSignalAppId: 'da8adeff-e081-4df9-af56-412a0652f2ec',
        oauthClientId: '15129741696-gg0p598ba13ijb4cb7tk3rdai3fmu5bg.apps.googleusercontent.com',
        oauthClientIdAlt: '547238816572-o7leufrdui424kdjpu0nsee0norhok48.apps.googleusercontent.com',
        geolocationApiKey: '726f901fb0da17',
        oktaIssuerDomain: 'https://dev-21489187.okta.com',
        oktaClientId: '0oac0x5x0r6iIgdfl5d6',
        hotjarId: '1819081',
        clarityId: 'n7by3oys6s',
        reCaptchaApiKey: '6LcgkYsgAAAAAOkua2GPCD5SUkZKDfxWShxxkfRD',
        intercomAppId: DEFAULT_INTERCOM_APP_ID,
        openAiClientId: '',
        ancestorsRegex: /^https:\/\/([a-zA-Z0-9-]+)-(\d+)lu-script\.googleusercontent\.com(?:\/userCodeAppPanel)?$/,
        dynamsoftKey: (
            'DLS2eyJoYW5kc2hha2VDb2RlIjoiMTA0MDc0NTA5LVRYbFhaV0pRY205cSIsIm1haW5TZXJ2ZXJVUkwiOiJodHRwczovL21' +
            'kbHMuZHluYW1zb2Z0b25saW5lLmNvbSIsIm9yZ2FuaXphdGlvbklEIjoiMTA0MDc0NTA5Iiwic3RhbmRieVNlcnZlclVSTC' +
            'I6Imh0dHBzOi8vc2Rscy5keW5hbXNvZnRvbmxpbmUuY29tIiwiY2hlY2tDb2RlIjoxMjgxNTY3MDUyfQ=='
        ),
        stripePublishableKeyV42: 'pk_test_51TQst5L71YIwxUx30X5KfKGdAalqzyOLkOX5LQBgG1OhSr1S958GNXqz2P5APD4zwI3O26vmhwcinMARi1Zh0b2I00ROE0SH6N',
        stripePublishableKeyEU: 'pk_test_aNiFzeQoZ6Xyk7XThjPaTRjX'
    },
    [Environment.BETA]: {
        name: Environment.BETA,
        appURL: 'https://beta.sheetgo.com',
        apiURL: 'https://beta-api.sheetgo.com',
        wsURL: 'https://beta-api.sheetgo.com',
        msappURL: 'https://beta-msapp.sheetgo.com',
        formsAppURL: 'https://beta-forms.sheetgo.com',
        dashboardsAppURL: 'https://beta-dashboards.sheetgo.com',
        barcodeDetectorURL: 'https://testing-barcode-scanner-x3efltvidq-uc.a.run.app',
        oneSignalAppId: 'da8adeff-e081-4df9-af56-412a0652f2ec',
        oauthClientId: '15129741696-gg0p598ba13ijb4cb7tk3rdai3fmu5bg.apps.googleusercontent.com',
        oauthClientIdAlt: '547238816572-o7leufrdui424kdjpu0nsee0norhok48.apps.googleusercontent.com',
        geolocationApiKey: '726f901fb0da17',
        oktaIssuerDomain: 'https://dev-21489187.okta.com',
        oktaClientId: '0oac0x5x0r6iIgdfl5d6',
        hotjarId: '1819081',
        clarityId: 'n7by3oys6s',
        reCaptchaApiKey: '6LcgkYsgAAAAAOkua2GPCD5SUkZKDfxWShxxkfRD',
        intercomAppId: DEFAULT_INTERCOM_APP_ID,
        openAiClientId: '',
        ancestorsRegex: /^https:\/\/([a-zA-Z0-9-]+)-(\d+)lu-script\.googleusercontent\.com(?:\/userCodeAppPanel)?$/,
        dynamsoftKey: (
            'DLS2eyJoYW5kc2hha2VDb2RlIjoiMTA0MDc0NTA5LVRYbFhaV0pRY205cSIsIm1haW5TZXJ2ZXJVUkwiOiJodHRwczovL21' +
            'kbHMuZHluYW1zb2Z0b25saW5lLmNvbSIsIm9yZ2FuaXphdGlvbklEIjoiMTA0MDc0NTA5Iiwic3RhbmRieVNlcnZlclVSTC' +
            'I6Imh0dHBzOi8vc2Rscy5keW5hbXNvZnRvbmxpbmUuY29tIiwiY2hlY2tDb2RlIjoxMjgxNTY3MDUyfQ=='
        ),
        stripePublishableKeyV42: 'pk_test_51TQst5L71YIwxUx30X5KfKGdAalqzyOLkOX5LQBgG1OhSr1S958GNXqz2P5APD4zwI3O26vmhwcinMARi1Zh0b2I00ROE0SH6N',
        stripePublishableKeyEU: 'pk_test_aNiFzeQoZ6Xyk7XThjPaTRjX'
    },
    [Environment.ALPHA]: {
        name: Environment.ALPHA,
        appURL: 'https://alpha.sheetgo.com',
        apiURL: 'https://alpha-api.sheetgo.com',
        wsURL: 'https://alpha-api.sheetgo.com',
        msappURL: 'https://alpha-msapp.sheetgo.com',
        formsAppURL: 'https://alpha-forms.sheetgo.com',
        dashboardsAppURL: 'https://alpha-dashboards.sheetgo.com',
        barcodeDetectorURL: 'https://testing-barcode-scanner-x3efltvidq-uc.a.run.app',
        oneSignalAppId: 'da8adeff-e081-4df9-af56-412a0652f2ec',
        oauthClientId: '15129741696-gg0p598ba13ijb4cb7tk3rdai3fmu5bg.apps.googleusercontent.com',
        oauthClientIdAlt: '547238816572-o7leufrdui424kdjpu0nsee0norhok48.apps.googleusercontent.com',
        geolocationApiKey: '726f901fb0da17',
        oktaIssuerDomain: 'https://dev-21489187.okta.com',
        oktaClientId: '0oac0x5x0r6iIgdfl5d6',
        hotjarId: '1819081',
        clarityId: 'n7by3oys6s',
        reCaptchaApiKey: '6LcgkYsgAAAAAOkua2GPCD5SUkZKDfxWShxxkfRD',
        intercomAppId: DEFAULT_INTERCOM_APP_ID,
        openAiClientId: '',
        ancestorsRegex: /^https:\/\/([a-zA-Z0-9-]+)-(\d+)lu-script\.googleusercontent\.com(?:\/userCodeAppPanel)?$/,
        dynamsoftKey: (
            'DLS2eyJoYW5kc2hha2VDb2RlIjoiMTA0MDc0NTA5LVRYbFhaV0pRY205cSIsIm1haW5TZXJ2ZXJVUkwiOiJodHRwczovL21' +
            'kbHMuZHluYW1zb2Z0b25saW5lLmNvbSIsIm9yZ2FuaXphdGlvbklEIjoiMTA0MDc0NTA5Iiwic3RhbmRieVNlcnZlclVSTC' +
            'I6Imh0dHBzOi8vc2Rscy5keW5hbXNvZnRvbmxpbmUuY29tIiwiY2hlY2tDb2RlIjoxMjgxNTY3MDUyfQ=='
        ),
        stripePublishableKeyV42: 'pk_test_51TQst5L71YIwxUx30X5KfKGdAalqzyOLkOX5LQBgG1OhSr1S958GNXqz2P5APD4zwI3O26vmhwcinMARi1Zh0b2I00ROE0SH6N',
        stripePublishableKeyEU: 'pk_test_aNiFzeQoZ6Xyk7XThjPaTRjX'
    },
    [Environment.LOCAL]: {
        name: Environment.LOCAL,
        appURL: 'https://local.sheetgo.com',
        /** Default LOCAL backend config */
        apiURL: 'https://local-api.sheetgo.com',
        wsURL: 'https://local-api.sheetgo.com',
        msappURL: 'https://local-msapp.sheetgo.com',
        formsAppURL: 'https://local-forms.sheetgo.com',
        dashboardsAppURL: 'https://local-dashboards.sheetgo.com',
        barcodeDetectorURL: 'https://testing-barcode-scanner-x3efltvidq-uc.a.run.app',
        oneSignalAppId: 'da8adeff-e081-4df9-af56-412a0652f2ec',
        // SG-12652 s54 #21 — LOCAL `oauthClientIdAlt` aligned to the shared client.
        // BE's local + testing envs set USE_ADDON_OAUTH_APP=0 (testing.env line 40), so the
        // `/auth/google/cli-version` endpoint always returns `cliVersion='default'` for LOCAL,
        // which routes FE to `oauthClientId` (the shared client). The previous `oauthClientIdAlt`
        // value was `547238816572-...` — a stale DEV-tier alternate-client that doesn't match
        // any BE `GOOGLE_APP_CLIENT_SECRET` in non-prod envs (BE only has the secret for
        // 15129741696). Setting alt = shared closes the door on FE-picks-alt-branch races
        // (transient state drift) without changing the happy-path behavior. PROD/STAGING/NEW
        // keep their `oauthClientIdAlt='94172092257-...'` (the real addon client, paired with
        // prod.env GOOGLE_APP_CLIENT_ID_ADDON).
        oauthClientId: '15129741696-gg0p598ba13ijb4cb7tk3rdai3fmu5bg.apps.googleusercontent.com',
        oauthClientIdAlt: '15129741696-gg0p598ba13ijb4cb7tk3rdai3fmu5bg.apps.googleusercontent.com',
        geolocationApiKey: '726f901fb0da17',
        oktaIssuerDomain: 'https://dev-21489187.okta.com',
        oktaClientId: '0oac9f2w3eFaSzHWn5d6',
        hotjarId: '1819081',
        clarityId: 'n7by3oys6s',
        reCaptchaApiKey: '6LcgkYsgAAAAAOkua2GPCD5SUkZKDfxWShxxkfRD',
        intercomAppId: DEFAULT_INTERCOM_APP_ID,
        openAiClientId: '',
        ancestorsRegex: /^https:\/\/([a-zA-Z0-9-]+)-(\d+)lu-script\.googleusercontent\.com(?:\/userCodeAppPanel)?$/,
        dynamsoftKey: (
            'DLS2eyJoYW5kc2hha2VDb2RlIjoiMTA0MDc0NTA5LVRYbFhaV0pRY205cSIsIm1haW5TZXJ2ZXJVUkwiOiJodHRwczovL21' +
            'kbHMuZHluYW1zb2Z0b25saW5lLmNvbSIsIm9yZ2FuaXphdGlvbklEIjoiMTA0MDc0NTA5Iiwic3RhbmRieVNlcnZlclVSTC' +
            'I6Imh0dHBzOi8vc2Rscy5keW5hbXNvZnRvbmxpbmUuY29tIiwiY2hlY2tDb2RlIjoxMjgxNTY3MDUyfQ=='
        ),
        stripePublishableKeyV42: 'pk_test_51TQst5L71YIwxUx30X5KfKGdAalqzyOLkOX5LQBgG1OhSr1S958GNXqz2P5APD4zwI3O26vmhwcinMARi1Zh0b2I00ROE0SH6N',
        stripePublishableKeyEU: 'pk_test_aNiFzeQoZ6Xyk7XThjPaTRjX'
        /** Alternative PROD backend for development */
        // apiURL: 'https://api.sheetgo.com',
        // wsURL: 'https://api.sheetgo.com',
        // msappURL: 'https://msapp.sheetgo.com',
        // formsAppURL: 'https://forms.sheetgo.com',
        // dashboardsAppURL: 'https://dashboards.sheetgo.com',
        // barcodeDetectorURL: 'https://prod-barcode-scanner-oyhudlts6q-uc.a.run.app',
        // oneSignalAppId: 'd89159e7-6b19-4748-8a0d-b8d1a24b6151',
        // oauthClientId: '15129741696-gg0p598ba13ijb4cb7tk3rdai3fmu5bg.apps.googleusercontent.com',
        // oauthClientIdAlt: '547238816572-o7leufrdui424kdjpu0nsee0norhok48.apps.googleusercontent.com',
        // geolocationApiKey: '726f901fb0da17',
        // oktaIssuerDomain: 'https://dev-21489187.okta.com',
        // oktaClientId: '0oac0x5x0r6iIgdfl5d6',
        // hotjarId: '2631381',
        // clarityId: 'n7q7fux3ep',
        // reCaptchaApiKey: '6LdhfEQhAAAAAOTjerf4Oa_D0YWv_dB_gwk-vOrp'
        // ancestorsRegex: new RegExp(
        //     '^https://n-7ixdqsk3ntqkmodnjzyunwcrhtieg7y7tpckjey-' +
        //     '(\\d+)lu-script\\.googleusercontent\\.com(?:/userCodeAppPanel)?$'
        // ),
        // dynamsoftKey: (
        //     'DLS2eyJoYW5kc2hha2VDb2RlIjoiMTA0MDc0NTA5LVRYbFhaV0pRY205cSIsIm1haW5TZXJ2ZXJVUkwiOiJodHRwczovL21' +
        //     'kbHMuZHluYW1zb2Z0b25saW5lLmNvbSIsIm9yZ2FuaXphdGlvbklEIjoiMTA0MDc0NTA5Iiwic3RhbmRieVNlcnZlclVSTC' +
        //     'I6Imh0dHBzOi8vc2Rscy5keW5hbXNvZnRvbmxpbmUuY29tIiwiY2hlY2tDb2RlIjoxMjgxNTY3MDUyfQ=='
        // )
    }
}

if (window.location.hostname === 'localhost') {
    window.location.replace(envs[Environment.LOCAL].appURL)
}

const settings = Object.values(envs)
    .find(env => env.appURL.includes(window.location.hostname))

const { name: currentEnv } = settings

const isLocalEnv = currentEnv === envs[Environment.LOCAL].name
const prodEnvSettings = envs[Environment.PROD]
const legacyEnvSettings = envs[Environment.LEGACY]
const isProdEnv = [Environment.PROD, Environment.PROD2, Environment.NEW].includes(currentEnv)

// SG-14196 — the Free-tile toggle (`freePlanEnabled`) was removed here: it was a
// build-time REACT_APP_ENABLE_FREE_PLAN read that never took effect (the deploy
// workflows that set it are disabled, and the live Cloud Build never sets it). It
// now lives in node-api's runtime app config, consumed on the web as
// `state.user.appConfig.enableFreePlan` (V42PricingPage), so nothing reads it here.

/**
 * Test if a link is for the Sheetgo website.
 *
 * @param {string} link - A given link.
 * @returns {boolean} If hostname is from website.
 */
const isLinkFromSheetgoWebsite = (link) => {
    const { hostname } = new URL(link)
    return SHEETGO_WEBSITE.includes(hostname)
}

const {
    appURL,
    apiURL,
    wsURL,
    msappURL,
    barcodeDetectorURL,
    formsAppURL,
    dashboardsAppURL,
    oneSignalAppId,
    oauthClientId,
    oauthClientIdAlt,
    geolocationApiKey,
    oktaIssuerDomain,
    oktaClientId,
    hotjarId,
    clarityId,
    reCaptchaApiKey,
    ancestorsRegex,
    intercomAppId,
    dynamsoftKey,
    openAiClientId,
    stripePublishableKeyV42,
    stripePublishableKeyEU
} = settings

/**
 * Check if the current origin is a valid app ancestor.
 *
 * @param {string} origin - The ancestor origin.
 * @returns {boolean} Representing if the ancestor origin is valid or not.
 */
const isURLFromValidAppIframeAncestor = (origin) => Boolean(origin && origin.match(ancestorsRegex))

export {
    SHEETGO_USER_AUTH_ENCRYPT_KEY,
    SHEETGO_APP_STATE_ENCRYPT_KEY,
    PLAN_YEAR_SUFFIX,
    currentEnv,
    appURL,
    msappURL,
    formsAppURL,
    dashboardsAppURL,
    isLocalEnv,
    apiURL,
    wsURL,
    oneSignalAppId,
    oauthClientId,
    oauthClientIdAlt,
    geolocationApiKey,
    oktaIssuerDomain,
    oktaClientId,
    hotjarId,
    clarityId,
    prodEnvSettings,
    legacyEnvSettings,
    isProdEnv,
    barcodeDetectorURL,
    reCaptchaApiKey,
    intercomAppId,
    dynamsoftKey,
    openAiClientId,
    isURLFromValidAppIframeAncestor,
    isLinkFromSheetgoWebsite,
    MAX_CELLS_TRANSFER_FORMAT,
    stripePublishableKeyV42,
    stripePublishableKeyEU,
    BRANDFETCH_CLIENT_ID
}
